import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import Notification from 'bundles/notification-center/components/Notification';
import type {
  Notification as NotificationType,
  UnverifiedEmailReminderNotificationMessage,
} from 'bundles/notification-center/types';

import _t from 'i18n!nls/notification-center';

type Props = {
  notification: UnverifiedEmailReminderNotificationMessage;
  onClick: (notification: NotificationType) => void;
};

const UnverifiedEmailReminderNotification = ({ notification, onClick }: Props) => {
  const {
    data: { orgName },
  } = notification;

  const header = (
    <>
      <b>{_t('Verify your recovery email')}</b>
      <br />
    </>
  );

  return (
    <Notification onClick={onClick} notification={notification} href="/account-setting">
      <FormattedHTMLMessage
        message={_t(
          '{header} Verify your recovery email to ensure access to your accomplishment in case you lose access to {orgName} account.'
        )}
        header={header}
        orgName={<b>{orgName}</b>}
      />
    </Notification>
  );
};

export default UnverifiedEmailReminderNotification;
